// extracted by mini-css-extract-plugin
export default {"Switch":"Switch-module__Switch__sKOZF","Full":"Switch-module__Full__jZpBA","Item":"Switch-module__Item__YoCnB","Selected":"Switch-module__Selected__Q2Rdw"};